exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".question-header{display:flex;align-items:center;padding:16px}.section-title{color:#707070;font-size:18px}.question-content{display:flex;align-items:center;justify-content:flex-start;gap:16px;padding:24px 16px;position:relative}.question-with-content{border-top:1px solid #dcdcdd}", ""]);

// exports
